module.exports = __webpack_public_path__ + "static/fonts/DINProBold.b87f9895.woff";